// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import grmEntity from './entities/grm.json';
import grmMenu from '../pages/grm/menu.json';
import grmFullForm from '../pages/grm/forms/full.json';
import grmContextForm from '../pages/grm/forms/context.json';
import grmMiniForm from '../pages/grm/forms/mini.json';
import grmLookupForm from '../pages/grm/forms/lookup.json';
import grmTableView from '../pages/grm/views/table.json';
import grmStagesView from '../pages/grm/views/stages.json';
import grmCardsView from '../pages/grm/views/cards.json';
import grmInlineView from '../pages/grm/views/inline.json';
import grmBacklogView from '../pages/grm/views/backlog.json';
import grmSplitView from '../pages/grm/views/split.json';
import grmCalendarView from '../pages/grm/views/calendar.json';
import grmDashboardView from '../pages/grm/views/dashboard.json';

/** Тип запису «Орган влади» зі сторінками пакета: меню, форми та подання з pages/grm/. */
export const grmDefinition: IRecordTypeDefinition = {
  ...grmEntity,
  views: assembleViewSet({
      table: grmTableView,
      stages: grmStagesView,
      cards: grmCardsView,
      inline: grmInlineView,
      backlog: grmBacklogView,
      split: grmSplitView,
      calendar: grmCalendarView,
      dashboard: grmDashboardView,
  }),
  form: grmFullForm,
  forms: { full: grmFullForm, context: grmContextForm, mini: grmMiniForm, lookup: grmLookupForm },
  menu: grmMenu,
} as IRecordTypeDefinition;
